<template>
  <table-layout title="فرم ها">
    <template #buttons>
      <b-row>

        <router-link :to="{ name: 'FormCreate' }" class="ml-2 mt-1">
          <b-button pill variant="purple">ساخت فرم</b-button>
        </router-link>

        <LanguageSelectBox @changeLanguage="getForms" module-name="form" class="mx-4"/>

      </b-row>

    </template>


    <template #table>

      <table class="table table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
        <thead>
        <tr>
          <th>شناسه</th>
          <th>نام</th>
          <th>سازنده</th>
          <th>#</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="form in forms">
          <th>{{ form.id }}</th>
          <td>{{ form.name }}</td>
          <td>{{ form.user.name }} {{ form.user.last_name }}</td>
          <td>

            <router-link target="_blank" class="h5"
                         :to="{ name: 'FormUpdate', params: { id: form.id } }"
            >
              <b-icon icon="pen" class="h5 mr-3"></b-icon>
            </router-link>


            <b-icon @click="removeFormItem(form)" icon="trash" class="h5 mr-3"></b-icon>

            <router-link target="_blank" class="h5"
                         :to="{ name: 'FormFills', params: { id: form.id } }"
            >
              <b-icon icon="archive-fill" class="h5 mr-3"></b-icon>
            </router-link>


            <b-icon icon="card-text" class="h5 mr-3" v-b-modal="`upload-paper-${form.id}`"/>

            <b-icon icon="person-check-fill" class="h5 mr-3" v-b-modal="`form-lessons-${form.id}`"/>

            <b-modal :id="`upload-paper-${form.id}`" hide-footer  >
              <div class="text-right" dir="rtl">
                <p class="h5">اپلود پاسخ نامه های {{form.name}}</p>
                <paper-answers :form="form"/>
              </div>
            </b-modal>

            <b-modal :id="`form-lessons-${form.id}`" size="lg" hide-footer  >
              <div class="text-right" dir="rtl">
                <p class="h5">درس های {{form.name}}</p>
                <form-lessons :form="form" />
              </div>
            </b-modal>

          </td>
        </tr>
        </tbody>
      </table>

      <b-row class="pt-3 mt-3">
        <pagination :meta="pagination" :on-change-page="changeProductsPage"/>
      </b-row>
    </template>


  </table-layout>
</template>

<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout.vue";
import Pagination from "../../components/dashboard/Pagination.vue";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";
import PaperAnswers from "../../components/dashboard/Form/PaperAnswers.vue";
import FormLessons from "../../components/dashboard/Form/FormLessons.vue";

export default {
  name: "FormArchive",
  components: {FormLessons, PaperAnswers, Pagination, TableLayout, LanguageSelectBox},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      forms: 'Form/getForms',
      pagination: 'Form/getPagination'
    })
  },
  methods: {
    changeProductsPage(page) {
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...{page: page}}})
      this.getForms(page)
    },
    async getForms(page = 1) {
      if (this.$route.query.page != undefined) {
        page = this.$route.query.page;
      }
      await this.$store.dispatch("Form/getForms", page);
    },
    async removeFormItem(form) {
      if (confirm('ایا از حذف ایتم اطمینان داردی؟')) {
        await this.$store.dispatch('Form/removeForm', form)
        await this.getForms();
      }
    }
  },
  async mounted() {
    await this.getForms();
  },
};
</script>